<template>
  <div class="messageNotificationEn-page main-container">
    <v-topBarEn></v-topBarEn>
    <v-publicBanner :bannerInfo="bannerInfo"></v-publicBanner>
    <div class="public-banner-bot-comtent">
      <el-tabs v-model="activeName" @tab-click="handleClick">

        <el-tab-pane :label="`To-do list ${numberInfo.toDoNumber ? `(${numberInfo.toDoNumber})`: ''}`" name="0">
          <div class="search-wrap">
            <el-input placeholder="Enter Keyword" v-model="keyword" @keyup.enter.native="searchByKeyword">
              <i slot="suffix" class="el-input__icon el-icon-search cursor-pointer" @click="searchByKeyword"></i>
            </el-input>
          </div>
          <v-messageTableEn v-loading="loading" :activeName="activeName" :productLine="productLine" :tableData="toDoMessageData" @changeSourceGetList="changeSourceGetList"></v-messageTableEn>
          <el-pagination
                  @current-change="currentPageChange"
                  :current-page.sync="pageNo1"
                  background
                  layout="prev, pager, next"
                  :total="doneTotal">
          </el-pagination>
        </el-tab-pane>


        <el-tab-pane :label="`Message notification ${numberInfo.systemMessageNumber ? `(${numberInfo.systemMessageNumber})`: ''}`" name="2">
          <div style="padding:0 0 20px;min-width: 600px;">
            <el-button size="small" plain @click="allRead">Mark All as Read</el-button>
            <div class="pull-right search-wrap">
              <el-input placeholder="Enter Keyword" v-model="keyword" @keyup.enter.native="searchByKeyword">
                <i slot="suffix" class="el-input__icon el-icon-search cursor-pointer" @click="searchByKeyword"></i>
              </el-input>
            </div>

          </div>
          <v-messageTableEn v-loading="loading" :activeName="activeName" :productLine="productLine" :tableData="noticeMessageData" @changeSourceGetList="changeSourceGetList"></v-messageTableEn>
          <el-pagination
                  @current-change="currentPageChange2"
                  :current-page="pageNo2"
                  background
                  layout="prev, pager, next"
                  :total="noticeMessageTotal">
          </el-pagination>
        </el-tab-pane>

        <el-tab-pane :label="`Completed ${numberInfo.messageNumber ? `(${numberInfo.messageNumber})`: ''}`" name="1">
          <div class="search-wrap">
            <el-input placeholder="Enter Keyword" v-model="keyword" @keyup.enter.native="searchByKeyword">
              <i slot="suffix" class="el-input__icon el-icon-search cursor-pointer" @click="searchByKeyword"></i>
            </el-input>
          </div>
          <v-messageTableEn v-loading="loading" :activeName="activeName" :productLine="productLine" :tableData="alreadyMessageData" @changeSourceGetList="changeSourceGetList"></v-messageTableEn>
          <el-pagination
                  @current-change="currentPageChange3"
                  :current-page="pageNo3"
                  background
                  layout="prev, pager, next"
                  :total="alreadyDoTotal">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
  import topBarEn from '@/components/topBarEn'
  import publicBanner from '@/components/publicBanner'
  import messageTableEn from '@/components/messageTableEn'
  export default {
    data () {
      return {
        loading: false,
        bannerInfo: {
          title: 'Message notification',
          content: ""
        },
        activeName: '0',
        toDoMessageData: [],  // 代办事项
        doneTotal: 0,
        pageNo1: 1,

        noticeMessageData: [],  // 消息通知
        noticeMessageTotal: 0,
        pageNo3: 1,

        alreadyMessageData: [],  // 已办事项
        alreadyDoTotal: 0,
        pageNo2: 1,

        keyword: "",
        isFinish: 0,
        productLine: '',
        pageSize: 10,
        numberInfo: {
          toDoNumber: 0,  //代办
          systemMessageNumber: 0,  // 消息
          messageNumber: 0  // 已办
        }
      }
    },
    components: {
      'v-topBarEn': topBarEn,
      'v-publicBanner': publicBanner,
      'v-messageTableEn': messageTableEn
    },
    created () {
      this.findTodoInfo(0)
      this.findTodoInfo(2)
      this.findTodoInfo(1)
    },
    methods:{
      // 待办事项
      findTodoInfo (isFinish = 0, pageNo = 1 ) {
        this.loading = true
        let params = {
          keyword: this.keyword,
          pageNo: pageNo,
          pageSize: this.pageSize,
          productLine: this.productLine
        }
        let url = "/onelink.mdata.main.api/message/findTodoInfo"
        if (isFinish != '2') {
          url = "/onelink.mdata.main.api/message/findTodoInfo"
          params.isFinish = isFinish
        } else {
          url = "/onelink.mdata.main.api/message/findNoticeInfo"
        }

        this.$axios.post(url, params).then((res) => {
          this.loading = false
          let data = res.data
          if (isFinish == '2') {  // 消息通知
            this.noticeMessageData = data.queryNotifyResponse.list;
            this.noticeMessageTotal = Number(data.queryNotifyResponse.pageInfo.totalRecords);
            this.numberInfo.systemMessageNumber = data.systemMessageNumber
            this.numberInfo.messageNumber = data.alreadyDoNumber
            this.numberInfo.toDoNumber = data.toDoNumber
          } else if (isFinish == 1) {  // 已办
            this.alreadyMessageData = data.queryTodoResponse.list
            this.alreadyDoTotal = Number(data.queryTodoResponse.pageInfo.totalRecords);
            this.numberInfo.messageNumber = data.queryTodoResponse.pageInfo.totalRecords || data.alreadyDoNumber
            this.numberInfo.toDoNumber = data.toDoNumber
            this.numberInfo.systemMessageNumber = data.systemMessageNumber
          } else { //代办
            this.toDoMessageData = data.queryTodoResponse.list
            this.doneTotal = Number(data.queryTodoResponse.pageInfo.totalRecords);
            this.numberInfo.toDoNumber = data.toDoNumber
            this.numberInfo.systemMessageNumber = data.systemMessageNumber
            this.numberInfo.messageNumber = data.alreadyDoNumber
          }
        }).catch((err) => {
          console.log(err)
        })
      },

      // 通过来源筛选
      changeSourceGetList (productLine) {
        this.productLine = productLine
        this.findTodoInfo(this.activeName)
        switch (this.activeName) {
          case '0':
            this.pageNo1 = 1
            break;
          case '1':
            this.pageNo2 = 1
            break;
          case '2':
            this.pageNo3 = 1
            break;
        }
        this.findTodoInfo(this.activeName)
      },

      // 搜索
      searchByKeyword () {
        this.pageNo1 = 1;
        this.findTodoInfo(this.activeName, this.pageNo1)
      },

      //全部标为已读
      allRead(){
        this.$confirm('Continue to mark all unread messages as read?and this action cannot be cancelled', '', {
          confirmButtonText: 'Continue',
          cancelButtonText: 'Cancel',
          type: 'warning',
          lockScroll:false,
          customClass:'allReadConfirm',
          iconClass:'el-icon-warning-outline'
        }).then(() => {
          this.$axios.post('/onelink.mdata.main.api/message/markAllRead', {
          }).then((res) => {
            if(res.data.data.operateResult){
              this.$message({
                type: 'success',
                message: 'Marked all unread messages as read successfully'
              });
              this.findTodoInfo(0)
            }
          }).catch((err) => {
            console.log(err)
          })
        }).catch(() => {
        });
      },

      handleClick(tab, event) {
        if (!this.keyword) {
          return false;
        }
        this.findTodoInfo(tab.name)
      },

      currentPageChange (val) {
        this.pageNo1 = val;
        this.findTodoInfo(this.activeName, this.pageNo1)
      },

      currentPageChange2 (val) {
        this.pageNo2 = val;
        this.findTodoInfo(this.activeName, this.pageNo2)
      },

      currentPageChange3 (val) {
        this.pageNo3 = val;
        this.findTodoInfo(this.activeName, this.pageNo3)
      }


    }
  }
</script>

<style scoped lang="stylus">
  .messageNotificationEn-page {
    background-color: #f5f6fa;
    min-height: 100vh;
    /deep/ .el-tabs__content{
      overflow: visible;
    }
    /deep/ .el-tabs__item{
      position: relative;
      font-size: 18px;
      margin-bottom: 20px;
      padding: 0 26px;
      &:after{
        position: absolute;
        content: '';
        top: 12px;
        right: 0;
        width: 1px;
        height: 22px;
        background-color: #A8ACB2;
        transform: rotate(15deg);
      }
      &:last-child{
        &:after{
          display: none;
        }
      }
    }
    .publicBanner {
      background: url(https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/message_banner.png) no-repeat top;
    }
    .el-pagination{
      margin-top: 24px;
      text-align: right;
    }
    .search-wrap{
      text-align: right;
      padding-bottom: 16px;
      .el-input{
        width: 400px;
        height: 40px
        line-height: 40px;
        /deep/ .el-input__inner{
          border-radius: 20px;
        }
      }
      /deep/ .el-input__suffix{
        right: 10px;
        font-size: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/messageNotificationEn/index.vue